import {Deserializable} from "./deserializable.model";

export class SubjectInvoice {

//   subject_billing_item_id?: number;
//   billing_task_name?: string;
//   myob_tax_code_id?: number;
//   myob_account_code_id?: number;
//   billing_task_description?: string;
//   billing_task_fee?: number;
//   billing_task_id?: number;
//   subject_id: number;
//   subject_number?: number;
//   job_id: number;
//   job_number?: number;
//   invoice_status?: string;

invoice_id?: Number; 
invoice_number?: string;
job_id?: number;
to_brand_id?: number;
subject_id?: number;
job_type_id?: number;
file_id?: number;
created_by?: number;
date_created?: string;
invoice_total?: number;
invoice_gst?: number;
invoice_status_id?;
invoice_payment_status_id?;
invoice_communication_status_id?;
from_brand_id?: number;
due_date?: string;
invoice_subtotal?: number;
invoice_payment_total?: number;
invoice_remaining_total?: number;

job_number?: string;
subject_number?: string;
updated_by?: number;
updated_date?: string;

is_job_invoice?: number; // 1 if so.
to_brand_name?: string;

myob_id?: string;
sync_with_myob?;
myob_array?: any;


created_date_from?: any;
created_date_to?: string;
updated_date_from?: any;
updated_date_to?: string;
brand_type_id?;
access_level?;
myob_sync_status?;

UID?;
Number?;
Date?;
CustomerPurchaseOrderNumber?;
CustomerUID?;
CustomerName?;
CustomerDisplayID?;
PromisedDate?;
BalanceDueAmount?;
BalanceDueAmountForeign?;
Status?;
TermsPaymentIsDue?;
TermsDiscountDate?;
TermsBalanceDueDate?;
TermsDiscountForEarlyPayment?;
TermsMonthlyChargeForLatePayment?;
TermsDiscountExpiryDate?;
TermsDiscount?;
TermsDueDate?;
TermsFinanceCharge?;
IsTaxInclusive?;
Subtotal?;
SubtotalForeign?;
Freight?;
FreightForeign?;
FreightTaxCodeUID?;
TotalTax?;
TotalTaxForeign?;
TotalAmount?;
TotalAmountForeign?;
CategoryUID?;
SalespersonUID?;
Comment?;
ShippingMethod?;
JournalMemo?;
ReferralSource?;
InvoiceDeliveryStatus?;
LastPaymentDate?;
CanApplySurcharge?;
OrderUID?;
OnlinePaymentMethod?;
ForeignCurrency?;
CurrencyExchangeRate?;
LastModified?;
URI?;
RowVersion?;

po_number?;


  // ? what does this really do? (no encoding or deserialisation required...)
  // deserialize(input: any): SubjectInvoice {
  //   Object.assign(this, input);

  //   return this;
  // }

  /*
invoice_id
invoice_number
job_id
to_brand_id
subject_id
job_type_id
file_id
created_by
date_created
invoice_total
invoice_gst
invoice_status_id
invoice_payment_status_id
invoice_communication_status_id
from_brand_id
due_date
invoice_subtotal
  */


}
